/**
 * What to tell the user when saving a partner brand is refused, by the exception the backend names in its
 * error body. Its own message is meant for developers (e.g. "updatePartnerBrand.arg1.labourCost: must be..."),
 * so it is never shown as it is.
 */
const MESSAGES_BY_EXCEPTION: {[exception: string]: string} = {
	IllegalDomainNameException: "The website is not a valid address.",
	UserHasNoBusinessDevelopmentPartnerRoleException: "The Business Development Partner no longer has the BDP role. Choose another one.",
	UserHasNoAgentRoleException: "The Account Manager no longer has the Agent role. Choose another one.",
	UserHasNoThirdPartyEngineerRoleException: "The Lead User must have the Lead User role. Choose another one.",
	MissingPartnerBrandException: "The Lead User must be a user of this partner brand. Choose another one.",
	UserNotFoundException: "One of the selected users no longer exists. Check the Team and the Account Manager.",
	BrandNotFoundException: "The parent brand no longer exists. Choose another one.",
	UtilityNotFoundException: "The default utility no longer exists. Choose another one.",
	MerchantNotFoundException: "The preferred merchant no longer exists. Choose another one.",
	MerchantBranchLocationNotFoundException: "The merchant branch no longer exists. Choose another one.",
	QuoteEmailStyleNotFoundException: "The quote e-mail theme no longer exists. Choose another one.",
	SiteNotFoundException: "The business address could not be found. Enter it again.",
	AttachmentNotFoundException: "The logo could not be found. Upload it again.",
	GasNumberIsNotPresentException: "The gas certificate journey needs a Gas safe number."
};

/**
 * Message for a failed partner brand save.
 * @param error what the request failed with.
 * @param name name the brand was being saved with.
 */
export function partnerBrandSaveErrorMessage(error: any, name: string): string {
	const response = error && error.response;
	if (response && response.status === 409) {
		return `Partner brand with name '${name}' exists`;
	}
	const exception = response && response.data && response.data.exception;
	return MESSAGES_BY_EXCEPTION[exception] || "Partner brand update failed";
}
